var Component = require("!../../../../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./table.vue"),
  /* template */
  require("!!../../../../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6f173ebe\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./table.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_xiaozhu@2022.4.8@xiaozhu/vue/components/admin/table.vue
// module id = 98
// module chunks = 49